import { render, staticRenderFns } from "./discount-management.vue?vue&type=template&id=9da4b8b0&scoped=true"
import script from "./discount-management.vue?vue&type=script&lang=js"
export * from "./discount-management.vue?vue&type=script&lang=js"
import style0 from "./discount-management.vue?vue&type=style&index=0&id=9da4b8b0&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./discount-management.vue?vue&type=style&index=2&id=9da4b8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da4b8b0",
  null
  
)

export default component.exports